<template>
  <FormModal :data="data" endpoint="host-agencies" title="New Host Agency" v-bind="$attrs" @success="success">
    <InputGroup label="Name" name="name">
      <TextInput v-model="data.name" @input="onNameChange" />
    </InputGroup>

    <InputGroup label="Slug" name="slug">
      <TextInput v-model="data.slug" />
    </InputGroup>

    <InputGroup label="Logo" name="logo">
      <ImageInput v-model="data.logo" />
    </InputGroup>
  </FormModal>
</template>

<script>
export default {
  data: () => ({
    data: {
      name: null,
      slug: null,
      logo: null
    }
  }),
  methods: {
    onNameChange(name) {
      this.data.slug = name.replace(/\s+/g, "-").toLowerCase()
    },
    success(result) {
      this.$notification.success(`Host agency **${this.data.name}** successfully created.`)
      this.$emit("close", result)
    }
  }
}
</script>
